// Others
import axiosClient from './axiosClient';
import { urlApiVenue } from '~/utils/constants/apis';
import { IBodyUpdate } from '~/utils/interface/common';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IDetailVenue, IQueryParamVenue, IVenue } from '~/utils/interface/venue';

const venueApi = {
  getListVenue: (params: IQueryParamVenue) => {
    const url = urlApiVenue.getListVenue;
    return axiosClient.get<IBaseResponse<IListDataResponse<IVenue[]>>>(url, { params });
  },

  getDetailVenue: (id: string) => {
    const url = urlApiVenue.getDetailVenue(id);
    return axiosClient.get<IBaseResponse<IDetailVenue>>(url);
  },

  createVenue: (formData: FormData) => {
    const url = urlApiVenue.createVenue;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  editVenue: (payload: IBodyUpdate<FormData>) => {
    const { id, body } = payload;
    const url = urlApiVenue.editVenue(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteVenue: (id: string) => {
    const url = urlApiVenue.deleteVenue(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default venueApi;
